import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGetCurrentLoanApplicationID } from "@krea/customer-features/hooks";

import { deleteFile } from "@krea/customer-features/store/field-requests/api";
import {
  DELEGATED_FIELD_REQUESTS_STORE_KEY,
  ONE_FIELD_REQUEST_STORE_KEY,
  SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY,
} from "@krea/customer-features/store/queryClient";

export const useDeleteFile = () => {
  const queryClient = useQueryClient();
  const loanApplicationID = useGetCurrentLoanApplicationID();

  return useMutation<
    undefined,
    unknown,
    { fileID: string; fieldRequestID: string; isDelegated?: boolean }
  >({
    mutationFn: async ({ fileID }) => {
      deleteFile(fileID);
    },
    onSuccess: async (_, { fieldRequestID, isDelegated }) => {
      // Delay added to ensure that the file is deleted properly due to the cascading effect in the backend
      await new Promise((resolve) => setTimeout(resolve, 500));

      await queryClient.invalidateQueries({
        queryKey: [ONE_FIELD_REQUEST_STORE_KEY, fieldRequestID],
      });
      await queryClient.invalidateQueries([
        SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY,
        loanApplicationID,
      ]);

      if (isDelegated) {
        await queryClient.invalidateQueries({
          queryKey: [DELEGATED_FIELD_REQUESTS_STORE_KEY],
        });
      }
    },
    onError: (err) => {
      console.error("Failed deleting file", err);
    },
  });
};
